import { RefObject } from 'react';
import { Popover } from 'ui/popover';
import {
  PopoverRow,
  StyledTrigger,
} from 'modules/experiments/components/pages/monitor/header/Styled';
import { ExperimentState } from 'modules/graphql';
import { WebLink2 } from 'ui/theme';
import { StatusBadge } from 'modules/experiments/components/ui';
import { WordBreakLabel } from 'modules/experiments/components/pages/index/sections/table/cells/Styled';
import { useExperimentsTranslations } from 'modules/experiments/hooks';

import { StyledExperimentPopoverContent, DetailSpacer } from './styled';

type ExperimentPopoverProps = {
  open: boolean;
  experimentName: string;
  experimentNameRef: RefObject<HTMLSpanElement>;
  href: string;
  experimentState: ExperimentState;
};

export const ExperimentPopover = ({
  open,
  experimentName,
  experimentNameRef,
  href,
  experimentState,
}: ExperimentPopoverProps) => {
  const { t } = useExperimentsTranslations();

  // Campaign Link
  const goToExperiment = () => {
    window.location.href = href;
  };

  return (
    <Popover open={open}>
      <StyledExperimentPopoverContent side="top" data-test="experiment-link-popover-content">
        <PopoverRow>
          <StatusBadge state={experimentState} />
          <DetailSpacer>•</DetailSpacer>
          <WebLink2 onClick={goToExperiment}>
            {t('chooseCampaign.experimentLinkActionLabel')}
          </WebLink2>
        </PopoverRow>
      </StyledExperimentPopoverContent>
      <StyledTrigger asChild>
        <WordBreakLabel ref={experimentNameRef}>{experimentName}</WordBreakLabel>
      </StyledTrigger>
    </Popover>
  );
};
